import React from 'react';

// Lit side on the right while waxing, as seen from the northern hemisphere.
function litPath(angle, r) {
  const k = Math.cos((angle * Math.PI) / 180);
  const rx = Math.abs(k) * r;
  const waxing = angle < 180;
  const outer = waxing ? 1 : 0;
  const inner = waxing ? (k > 0 ? 0 : 1) : (k > 0 ? 1 : 0);
  return `M 0 ${-r} A ${r} ${r} 0 0 ${outer} 0 ${r} A ${rx} ${r} 0 0 ${inner} 0 ${-r} Z`;
}

const MoonIcon = ({ angle = 180, size = 40, className = '', title }) => {
  const r = 48;
  return (
    <svg
      className={`moon-icon ${className}`.trim()}
      width={size}
      height={size}
      viewBox="-50 -50 100 100"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <circle r={r} fill="#3a3152" />
      <path d={litPath(angle, r)} fill="#FFF6D8" />
      <circle r={r} fill="none" stroke="#2D3436" strokeWidth="3" />
    </svg>
  );
};

export default MoonIcon;
